class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.openMode = this.dataset.openMode || 'click';
    this.openDelayMs = 100;
    this.closeDelayMs = 280;
    this.openTimeout = null;
    this.closeTimeout = null;

    if (this.openMode === 'hover') {
      this.onMouseEnter = this.onMouseEnter.bind(this);
      this.onMouseLeave = this.onMouseLeave.bind(this);
      this.addEventListener('mouseenter', this.onMouseEnter);
      this.addEventListener('mouseleave', this.onMouseLeave);
    }
  }

  disconnectedCallback() {
    if (this.openMode === 'hover') {
      window.clearTimeout(this.openTimeout);
      window.clearTimeout(this.closeTimeout);
      this.removeEventListener('mouseenter', this.onMouseEnter);
      this.removeEventListener('mouseleave', this.onMouseLeave);
    }
  }

  onMouseEnter() {
    if (!window.matchMedia('(min-width: 990px)').matches) return;
    window.clearTimeout(this.closeTimeout);

    if (this.mainDetailsToggle.hasAttribute('open')) return;

    window.clearTimeout(this.openTimeout);
    this.openTimeout = window.setTimeout(() => {
      this.mainDetailsToggle.setAttribute('open', '');
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
    }, this.openDelayMs);
  }

  onMouseLeave() {
    if (!window.matchMedia('(min-width: 990px)').matches) return;
    window.clearTimeout(this.openTimeout);
    if (!this.mainDetailsToggle.hasAttribute('open')) return;

    window.clearTimeout(this.closeTimeout);
    this.closeTimeout = window.setTimeout(() => {
      if (!this.matches(':hover')) this.close();
    }, this.closeDelayMs);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
